import React, { Component } from "react";
import { inject, observer } from "mobx-react"
import { Provider } from "mobx-react"
import { Icon, Switch } from 'antd'
import MyBetsCards from '../layoutComponents/MyBetsCards'
import UserStore from "../../stores/UserStore";
import { Tabs } from 'antd';
import BetSorter from './BetSorter';
import MyBetTable from '../layoutComponents/MyBetTable'

@observer(["eventStore", "UserStore", "AuthStore", "ViewStore", "web3Store", "AdminStore", "TeamStore"])
class MyBets extends Component {
    constructor(props) {
        super(props);
        this.state = {

            betsMade: {},
            betsTaken: {},
            allOrTimelineSwitch: true,
            allEventsAtOnce: null,
            wagerObjectList: [],
            timelineComponents: <Icon style={{ marginLeft: "47%", fontSize: '46px', color: '#08c' }} type="loading" />
        };
        this.handleClick = this.handleClick.bind(this);

        this.renderTimelineEventsComponents = this.renderTimelineEventsComponents.bind(this);
        this.renderAllEventsAtOnce = this.renderAllEventsAtOnce.bind(this);
        this.props.eventStore.queryEvents();
        this.props.TeamStore.queryTeams()
    }

    async componentWillMount() {
        this.props.ViewStore.changeView('My Bets');
        this.props.ViewStore.changeCurrentPage('MyBets');
        // this.props.UserStore.updateUser(this.props.AuthStore.userAuth.auth.accessToken);

    }
    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('MyBets')
    }

    async componentDidMount() {

        setTimeout(() => {
            this.renderAllEventsAtOnce();
        }, 1500);
        //  this.renderTimelineEventsComponents();

    }

    handleClick() {
        this.props.ViewStore.changeGridList()
    }

    renderEvent(event, makerTaker) {
        let time = new Date().getTime() / 1000;
        let startTime = new Date();
        startTime.setTime(event.startTime * 1000);
        let startTimeString = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();

        return (
            <MyBetsCards
                key={event._id}
                event={event}
                makerTaker={makerTaker} />
        );
    }

    renderAllEventsAtOnce() {
        const { eventStore, UserStore, AdminStore } = this.props;
        let allEventsBetOn = [];
        let allEventCardList = [];
        let allEventObjects = [];
        let wagerObjectList = [];

        for (let event of UserStore.betsMadeEvents.values()) {

            allEventsBetOn.push(event);

        }

        for (let event of UserStore.betsTakenEvents.values()) {
            let alreadyAdded = false;
            allEventsBetOn.forEach(preExistingEvent => {
                if (preExistingEvent._id == event._id) {
                    alreadyAdded = true;
                }
            });
            if (!alreadyAdded) {
                allEventsBetOn.push(event);
            }
        }

        allEventsBetOn.forEach(event => {
            UserStore.betsMade.forEach(wager => {
                if (wager.eventId == event._id) {
                    if (wager.cancelled) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "cancelled"
                        });
                    } else if (wager.taker == "" && Date.now() / 1000 > event.startTime + event.duration) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "untaken-postgame"
                        });
                    } else if (wager.taker == "" && Date.now() / 1000 < event.startTime + event.duration) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "untaken-pregame"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "taken-pregame"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "novotes-postgameprefinalized"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "novotes-postgamepostfinalized"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "onlymakervoted-preeventfinalized"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "onlytakervoted-preeventfinalized"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote == wager.takerWinVote) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "settled-nodispute"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "dispute-preeventfinalize"
                        });
                    }
                    else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && !wager.settled) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "dispute-settlednotpaid"
                        });
                    }
                    else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.settled) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "dispute-settledpaid"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "onlymakervoted-posteventfinalized"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "onlytakervoted-posteventfinalized"
                        });
                    } else if (wager.settled) {
                        wagerObjectList.push({
                            wager: wager,
                            maker: true,
                            status: "settled"
                        });

                    }
                }
            });

            UserStore.betsTaken.forEach(wager => {
                if (wager.eventId == event._id) {
                    if (wager.cancelled) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "cancelled"
                        });
                    } else if (wager.taker == "" && Date.now() / 1000 > event.startTime + event.duration) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "untaken-postgame"
                        });
                    } else if (wager.taker == "" && Date.now() / 1000 < event.startTime + event.duration) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "untaken-pregame"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "taken-pregame"
                        });

                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "novotes-postgameprefinalized"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "novotes-postgamepostfinalized"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "onlymakervoted-preeventfinalized"
                        });

                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "onlytakervoted-preeventfinalized"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote == wager.takerWinVote) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "settled-nodispute"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "dispute-preeventfinalize"
                        });
                    }
                    else if (wager.taker != "" && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && !wager.settled) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "dispute-settlednotpaid"
                        });
                    }
                    else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote && wager.settled) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "dispute-settledpaid"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "onlymakervoted-posteventfinalized"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "onlytakervoted-posteventfinalized"
                        });
                    } else if (wager.settled) {
                        wagerObjectList.push({
                            wager: wager,
                            taker: true,
                            status: "settled"
                        });
                    }
                }
            });

        });
        // console.log("wagerObject lsit : " + JSON.stringify(wagerObjectList));

        //this.setState({  allEventsAtOnce: <BetSorter wagerList={wagerObjectList} /> });
        this.setState({ wagerObjectList });
        this.renderTimelineEventsComponents(wagerObjectList);



    }
    renderTimelineEventsComponents(wagerObjectList) {
        const { eventStore, UserStore, AdminStore } = this.props;
        const TabPane = Tabs.TabPane;

        // Split up the wagers into their respective stages and then pass them into BetSorter seperately to render the correct MyBetCard
        let cancelledArray = [];
        let settledArray = [];
        let unTakenPreGameArray = [];
        let unTakenPostGameArray = [];
        let takenPreGameArray = [];
        let noVotesPostGameArray = [];
        let onlyMakerVotedPreEventFinalizedArray = [];
        let onlyTakerVotedPreEventFinalizedArray = [];
        let onlyMakerVotedPostEventFinalizedArray = [];
        let onlyTakerVotedPostEventFinalizedArray = [];
        let disputePreEventFinalizedArray = [];
        let settledWithNoDisputeArray = [];
        let settledDisputeNotPaidArray = [];
        let settledDisputePaidArray = [];

        let allEventsBetOn = [];

        UserStore.betsMadeEvents.forEach(event => {
            allEventsBetOn.push(event);
        });

        UserStore.betsTakenEvents.forEach(event => {
            let alreadyAdded = false;
            allEventsBetOn.forEach(preExistingEvent => {
                if (preExistingEvent._id == event._id) {
                    alreadyAdded = true;
                }
            });
            if (!alreadyAdded) {
                allEventsBetOn.push(event);
            }
        });

        allEventsBetOn.forEach(event => {
            UserStore.betsMade.forEach(wager => {
                if (wager.eventId == event._id) {
                    if (wager.cancelled) {
                        cancelledArray.push({
                            wager: wager,
                            maker: true,
                            status: "cancelled"
                        });
                    } else if (wager.taker == "" && Date.now() / 1000 > event.startTime + event.duration) {
                        unTakenPostGameArray.push({
                            wager: wager,
                            maker: true,
                            status: "untaken-postgame"
                        });
                    } else if (wager.taker == "" && Date.now() / 1000 < event.startTime + event.duration) {
                        unTakenPreGameArray.push({
                            wager: wager,
                            maker: true,
                            status: "untaken-pregame"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration) {
                        takenPreGameArray.push({
                            wager: wager,
                            maker: true,
                            status: "taken-pregame"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                        noVotesPostGameArray.push({
                            wager: wager,
                            maker: true,
                            status: "novotes-postgameprefinalized"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                        noVotesPostGameArray.push({
                            wager: wager,
                            maker: true,
                            status: "novotes-postgamepostfinalized"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                        onlyMakerVotedPreEventFinalizedArray.push({
                            wager: wager,
                            maker: true,
                            status: "onlymakervoted-preeventfinalized"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                        onlyTakerVotedPreEventFinalizedArray.push({
                            wager: wager,
                            maker: true,
                            status: "onlytakervoted-preeventfinalized"
                        });

                    } else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote == wager.takerWinVote) {
                        settledWithNoDisputeArray.push({
                            wager: wager,
                            maker: true,
                            status: "settled-nodispute"
                        });

                    } else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && !event.finalized && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod) {
                        disputePreEventFinalizedArray.push({
                            wager: wager,
                            maker: true,
                            status: "dispute-preeventfinalize"
                        });
                    }
                    else if (wager.taker != "" && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && !wager.settled) {
                        settledDisputeNotPaidArray.push({
                            wager: wager,
                            maker: true,
                            status: "dispute-settlednotpaid"
                        });
                    }
                    else if (wager.taker != "" && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.settled) {
                        settledDisputePaidArray.push({
                            wager: wager,
                            maker: true,
                            status: "dispute-settledpaid"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                        onlyMakerVotedPostEventFinalizedArray.push({
                            wager: wager,
                            maker: true,
                            status: "onlymakervoted-posteventfinalized"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                        onlyTakerVotedPostEventFinalizedArray.push({
                            wager: wager,
                            maker: true,
                            status: "onlytakervoted-posteventfinalized"
                        });
                    } else if (wager.settled) {
                        settledArray.push({
                            wager: wager,
                            maker: true,
                            status: "settled"
                        });
                    }

                }
            });

            UserStore.betsTaken.forEach(wager => {
                if (wager.eventId == event._id) {
                    if (wager.cancelled) {
                        cancelledArray.push({
                            wager: wager,
                            taker: true,
                            status: "cancelled"
                        });
                    } else if (wager.taker == "" && Date.now() / 1000 > event.startTime + event.duration) {
                        unTakenPostGameArray.push({
                            wager: wager,
                            taker: true,
                            status: "untaken-postgame"
                        });
                    } else if (wager.taker == "" && Date.now() / 1000 < event.startTime + event.duration) {
                        unTakenPreGameArray.push({
                            wager: wager,
                            taker: true,
                            status: "untaken-pregame"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration) {
                        takenPreGameArray.push({
                            wager: wager,
                            taker: true,
                            status: "taken-pregame"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                        noVotesPostGameArray.push({
                            wager: wager,
                            taker: true,
                            status: "novotes-postgameprefinalized"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                        noVotesPostGameArray.push({
                            wager: wager,
                            taker: true,
                            status: "novotes-postgamepostfinalized"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                        onlyMakerVotedPreEventFinalizedArray.push({
                            wager: wager,
                            taker: true,
                            status: "onlymakervoted-preeventfinalized"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                        onlyTakerVotedPreEventFinalizedArray.push({
                            wager: wager,
                            taker: true,
                            status: "onlytakervoted-preeventfinalized"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote == wager.takerWinVote) {
                        settledWithNoDisputeArray.push({
                            wager: wager,
                            taker: true,
                            status: "settled-nodispute"
                        });
                    } else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod) {
                        disputePreEventFinalizedArray.push({
                            wager: wager,
                            taker: true,
                            status: "dispute-preeventfinalize"
                        });
                    }
                    else if (wager.taker != "" && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && !wager.settled) {
                        settledDisputeNotPaidArray.push({
                            wager: wager,
                            taker: true,
                            status: "dispute-settlednotpaid"
                        });
                    }
                    else if (wager.taker != "" && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                        && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.settled) {
                        settledDisputePaidArray.push({
                            wager: wager,
                            taker: true,
                            status: "dispute-settledpaid"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                        onlyMakerVotedPostEventFinalizedArray.push({
                            wager: wager,
                            taker: true,
                            status: "onlymakervoted-posteventfinalized"
                        });
                    } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                        onlyTakerVotedPostEventFinalizedArray.push({
                            wager: wager,
                            taker: true,
                            status: "onlytakervoted-posteventfinalized"
                        });
                    } else if (wager.settled) {
                        settledArray.push({
                            wager: wager,
                            taker: true,
                            status: "settled"
                        });
                    }

                }
            });
        });

        //     let sortedBetsArray = <Tabs defaultActiveKey="1">
        //     <TabPane tab="Cancelled Bets" key="1"><BetSorter wagerList={cancelledArray} /></TabPane>
        //     <TabPane tab="Taken Bets - Pre Game" key="2"><BetSorter wagerList={takenPreGameArray} /></TabPane>
        //     <TabPane tab="Untaken Bets - Pre Game" key="3"><BetSorter wagerList={unTakenPreGameArray} /></TabPane>
        //     <TabPane tab="Untaken Bets - Post Game" key="4"><BetSorter wagerList={unTakenPostGameArray} /></TabPane>
        //     <TabPane tab="No Votes - Post Game" key="5"><BetSorter wagerList={noVotesPostGameArray} /></TabPane>
        //     <TabPane tab="Only Maker Voted - Pre Finalization" key="6"><BetSorter wagerList={onlyMakerVotedPreEventFinalizedArray} /></TabPane>
        //     <TabPane tab="Only Taker Voted - Pre Finazlization" key="7"><BetSorter wagerList={onlyTakerVotedPreEventFinalizedArray} /></TabPane>
        //     <TabPane tab="Dispute - Pre Finalization" key="8"><BetSorter wagerList={disputePreEventFinalizedArray} /></TabPane>
        //     <TabPane tab="Setlled Bets" key="9"><BetSorter wagerList={settledWithNoDisputeArray} /></TabPane>
        //     <TabPane tab="Disputed Unpaid Bets" key="10"><BetSorter wagerList={settledDisputeNotPaidArray} /></TabPane>
        //     <TabPane tab="Disputed Paid Bets" key="11"><BetSorter wagerList={settledDisputePaidArray} /></TabPane>
        //   </Tabs>



        let sortedBetsArray = <Tabs defaultActiveKey="2">
            {/* <TabPane tab="All" key="1">
                <BetSorter all = {true} wagerList={wagerObjectList} />
            </TabPane> */}
            <TabPane tab="Open (Pre-Game)" key="2">
                <BetSorter wagerList={takenPreGameArray} />
                <BetSorter wagerList={unTakenPreGameArray} />
            </TabPane>
            <TabPane tab="Open (Post-Game)" key="3">
                <BetSorter wagerList={unTakenPostGameArray} />
                <BetSorter wagerList={noVotesPostGameArray} />
                <BetSorter wagerList={onlyMakerVotedPreEventFinalizedArray} />
                <BetSorter wagerList={onlyTakerVotedPreEventFinalizedArray} />
                <BetSorter wagerList={onlyMakerVotedPostEventFinalizedArray} />
                <BetSorter wagerList={onlyTakerVotedPostEventFinalizedArray} />
                <BetSorter wagerList={disputePreEventFinalizedArray} />
                <BetSorter wagerList={settledDisputeNotPaidArray} />
            </TabPane>
            <TabPane tab="Settled" key="4">
                <BetSorter wagerList={settledWithNoDisputeArray} />
                <BetSorter wagerList={settledDisputePaidArray} />
                <BetSorter wagerList={settledArray} />
            </TabPane>
            <TabPane tab="Cancelled" key="5">
                <BetSorter wagerList={cancelledArray} />
            </TabPane>
        </Tabs>

        this.setState({ timelineComponents: sortedBetsArray });
    }

    renderMadeBetsEvents() {
        const { eventStore, UserStore } = this.props;
        let eventList = [];
        for (let event of UserStore.betsMadeEvents.values()) {
            eventList.push(this.renderEvent(event, "maker"));
        }
        return eventList;
    }

    renderTakenBetsEvents() {
        const { UserStore } = this.props;
        let eventList = [];
        for (let event of UserStore.betsTakenEvents.values()) {
            eventList.push(this.renderEvent(event, "taker"));
        }
        return eventList;
    }


    render() {
        let gridColumnEvents = "";
        let gridListIcon = "";
        if (this.props.ViewStore.getHeaderState === true) {
            gridColumnEvents = '100%';

        } else {
            if (this.props.ViewStore.getGridList === "list") {
                gridListIcon = <Icon type="appstore" onClick={this.handleClick} />
                gridColumnEvents = '100%';
            } else {
                gridListIcon = <Icon type="bars" onClick={this.handleClick} />
                gridColumnEvents = '49.2% 49.2%';
            }
        }
        const { eventStore } = this.props;

        return (
            <Provider>
                <div className="featured-events-wrap">
                    <div className="my-bets-view-options">
                        {/* <div className="grid-list-switch"><Switch checkedChildren="ALL BETS" unCheckedChildren="TIMELINE" onClick={this.handleSwitch} defaultChecked /></div> */}
                        <div className="grid-list-icon">{gridListIcon}</div>
                    </div>
                    {/* {this.state.allOrTimelineSwitch ? this.state.allEventsAtOnce : this.state.timelineComponents} */}
                    {/* {this.props.UserStore.loaded ? this.state.timelineComponents : <Icon style={{ marginLeft: "47%", fontSize: '46px', color: '#08c' }} type="loading" />} */}
                    {this.props.ViewStore.getGridList === "list" ? <MyBetTable data={this.state.wagerObjectList} /> : (this.props.UserStore.loaded ? this.state.timelineComponents : <Icon style={{ marginLeft: "47%", fontSize: '46px', color: '#08c' }} type="loading" />)}
                </div>
            </Provider>
        );
    }
}
export default MyBets;


// WEBPACK FOOTER //
// ./src/components/appComponents/MyBets.js